import type React from 'react';
import { MdPlaylistRemove } from 'react-icons/md';

type DataTableEmptyStateProps = {
  placeHolder?: React.ReactElement;
  colSpan: number;
};

/** Corpo da tabela quando a busca terminou sem registros. */
const DataTableEmptyState = ({ placeHolder, colSpan }: DataTableEmptyStateProps) => (
  <tbody>
    <tr>
      <td className="text-center" colSpan={colSpan}>
        <div className="d-flex flex-column h-100 align-items-center justify-content-center">
          {placeHolder ?? (
            <>
              <MdPlaylistRemove className="text-gray-500" style={{ fontSize: '5rem' }} />
              <span className="text-gray-500 fw-bold mt-1 fs-7">Lista vazia…</span>
            </>
          )}
        </div>
      </td>
    </tr>
  </tbody>
);

export default DataTableEmptyState;
